var _extends = require('babel-runtime/helpers/extends').default;

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default').default;

(function () {
  Motion.file('inspector/statetests.js', function (require) {
    var _mouseEventOffset = require('mouse-event-offset');

    var _mouseEventOffset2 = _interopRequireDefault(_mouseEventOffset);

    Motion.view('StateTests', function (view, on, $) {
      ;view.render(function () {
        return view.el(['Tests.Name', 1], null);
      });view.render(function () {
        return view.el(['Tests.Boolean', 1], null);
      });view.render(function () {
        return view.el(['Tests.Counter', 1], null);
      });view.render(function () {
        return view.el(['Tests.Props', 1], null);
      });view.render(function () {
        return view.el(['Tests.Circles', 1], null);
      });
    });
    Motion.view('Tests.Boolean', function (view, on, $) {
      var dead = false;view.render(function () {
        return view.el(
          ['h1', 1],
          null,
          'is tupac dead? ',
          dead.toString()
        );
      });view.render(function () {
        return view.el(
          ['button', 1],
          { onClick: function () {
              view.set('dead', dead = !dead);
              view.updateSoft();
            } },
          'toggle'
        );
      });
    });
    Motion.staticStyles('Tests.Props', {
      '$': '#_motiondevtools .ViewTests-Props'
    }, {
      '$': { marginTop: 20 }
    });
    Motion.view('Tests.Props', function (view, on, $) {
      var name = 'a string';view.render(function () {
        return view.el(['input', 1], {
          '__motionValue': name,
          '__motionOnChange': function (__motionval__) {
            view.set('name', name = __motionval__);
            view.updateSoft();
          }
        });
      });view.render(function () {
        return view.el(['Test.PropsChild', 1], { name: name });
      });
    });
    Motion.view('Test.PropsChild', function (view, on, $) {
      var name = view.prop('name', undefined);
      on.props(function () {
        name = view.getProp('name');
      });
      var count = 0;view.render(function () {
        return view.el(
          ['h1', 1],
          null,
          'my name is ',
          name
        );
      });view.render(function () {
        return view.el(
          ['h4', 1],
          null,
          'counter to test state ',
          count
        );
      });view.render(function () {
        return view.el(
          ['button', 1],
          { onClick: function () {
              view.set('count', count++, count, true);
              view.updateSoft();
            } },
          'up'
        );
      });
    });
    Motion.view('Tests.Counter', function (view, on, $) {
      var count = 0;view.render(function () {
        return view.el(
          ['h1', 1],
          null,
          'count is ',
          count
        );
      });view.render(function () {
        return view.el(
          ['button', 1],
          { onClick: function () {
              view.set('count', count++, count, true);
              view.updateSoft();
            } },
          'up'
        );
      });view.render(function () {
        return view.el(
          ['button', 2],
          { onClick: function () {
              view.set('count', count--, count, true);
              view.updateSoft();
            } },
          'down'
        );
      });
    });
    Motion.view('Tests.Deep', function (view, on, $) {
      var person = { name: 'nick', tools: ['js', 'juggling balls', 'coffee'] };view.render(function () {
        return view.el(
          ['h1', 1],
          null,
          'deep'
        );
      });view.render(function () {
        return view.el(
          ['h2', 1],
          null,
          JSON.stringify(person)
        );
      });
    });
    Motion.view('Tests.Name', function (view, on, $) {
      var first = 'nick';
      var last = 'cammarata';view.render(function () {
        return view.el(
          ['h2', 1],
          null,
          'name is ',
          first,
          ' ',
          last
        );
      });view.render(function () {
        return view.el(['input', 1], {
          '__motionValue': first,
          '__motionOnChange': function (__motionval__) {
            view.set('first', first = __motionval__);
            view.updateSoft();
          }
        });
      });view.render(function () {
        return view.el(['input', 2], {
          '__motionValue': last,
          '__motionOnChange': function (__motionval__) {
            view.set('last', last = __motionval__);
            view.updateSoft();
          }
        });
      });view.render(function () {
        return view.el(
          ['button', 1],
          { onClick: function () {
              view.set('first', first = 'nate');
              view.set('last', last = 'wienert');
              view.updateSoft();
            } },
          'nateify'
        );
      });
    });
    Motion.staticStyles('Tests.Circles', {
      '$circles': '#_motiondevtools circles.Tests-Circles, #_motiondevtools .Tests-Circles.circles, #_motiondevtools .ViewTests-Circles.circles'
    }, {
      '$circles': { position: 'relative', background: '#eee', height: 400, width: 400 }
    });
    Motion.view('Tests.Circles', function (view, on, $) {
      var coords = [[200, 200]];

      function addCircle(click) {
        view.set('coords', coords.push((0, _mouseEventOffset2.default)(click)), coords, true);
        view.updateSoft();
      }

      ;view.render(function () {
        return view.el(
          ['circles', 1],
          { onClick: addCircle },
          Motion.range(coords).map(function (_, _index) {
            return view.el(['Tests.Circle', 1, _, _index], {
              repeat: coords,
              key: '' + _[0] + _[1],
              left: _[0],
              top: _[1]
            });
          })
        );
      });
    });
    Motion.view('Tests.Circle', function (view, on, $) {
      var c = function c() {
        return Math.round(Math.random() * 255);
      };
      var base = {
        background: [c(), c(), c()],
        position: 'absolute',
        top: view.props.top,
        left: view.props.left,
        width: 118, height: 29,
        borderRadius: 27
      };
      var style = function style(scale) {
        return _extends({}, base, { transform: { scale: scale } });
      };view.render(function () {
        return view.el(['circle', 1], { style: style(1) });
      });
    });
  })
})();
//# sourceMappingURL=statetests.js.map
